import {createLazyFileRoute} from '@tanstack/react-router'

import Product from '@/views/Product/Product'

export const Route = createLazyFileRoute('/_shop/product/$productId/')({
  component: Product,
})
